"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nodeRequest = _interopRequireDefault(require("./node-request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _nodeRequest.default;
exports.default = _default;
module.exports = exports.default;
//# sourceMappingURL=index.js.map